<template>
  <div>
    <v-img
      contain
      :src="apiUrl + '/images/products/' + productImage + '?token=' + userToken"
      alt="clothes"
      class="cursor"
      @click="indexImage = 0"
      height="150"
      width="90"
    >
    </v-img>
    <div id="test">
      <CoolLightBox
        :items="productImages"
        :index="indexImage"
        @close="indexImage = null"
      >
      </CoolLightBox>
    </div>
  </div>
</template>
  
  <script>
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
export default {
  props: ["productImages", "productImage"],
  data() {
    return {
      apiUrl: this.$config.apiUrls.Dev,
      indexImage: null,
      userToken: this.$auth.userToken(),
    };
  },
  components: {
    CoolLightBox,
  },
};
</script>
  
  <style>
.cursor {
  cursor: pointer;
}
</style>